import { useSelector } from 'react-redux'

import { selectPrintCapture } from '@/stores/offers/printOfferModal'

// True while the print modal is capturing tabs as images. Tab components read this to hide
// interactive chrome (buttons, dropdowns, edit icons) that shouldn't appear in the printed PDF.
const usePrintCaptureMode = () => {
  const { isActive } = useSelector(selectPrintCapture)
  return isActive
}

export default usePrintCaptureMode
